// lazyLoad.js

export const lazyLoadDirective = {
  bind (el, binding) {
    const loadImage = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target
          if (img) {
            img.src = img.dataset.src
            observer.unobserve(entry.target)
            observer.disconnect()
          }
        }
      })
    }

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    }

    const observer = new IntersectionObserver(loadImage, options)
    observer.observe(el)
  }
}



// WEBPACK FOOTER //
// ./src/directives/lazyLoad.js